import React, { createContext, useContext } from "react";

const AppRuntimeContext = createContext(null);

export function AppRuntimeProvider({ app, children }) {
  return (
    <AppRuntimeContext.Provider value={app}>
      {children}
    </AppRuntimeContext.Provider>
  );
}

export function useRuntimeApp() {
  const app = useContext(AppRuntimeContext);
  if (!app) throw new Error("useRuntimeApp must be used inside an AppRuntimeProvider.");
  return app;
}
